import { ZodTypeAny, z } from "zod"

// Creates a zod schema to parse GQL field filters.
function createFilterInput<T extends ZodTypeAny>(valueSchema: T) {
  const schema = z.object({
    gte: valueSchema.optional(),
    gt: valueSchema.optional(),
    lte: valueSchema.optional(),
    lt: valueSchema.optional(),
    eq: valueSchema.optional().nullable(),
    neq: valueSchema.optional().nullable(),
    in: z.array(valueSchema).optional(),
    nin: z.array(valueSchema).optional(),
    op: z.union([z.literal("and"), z.literal("or")]).optional()
  })

  // Accepts the schema or an array of the schema.
  return z.union([schema, z.array(schema)]) as z.ZodUnion<
    [typeof schema, z.ZodArray<typeof schema>]
  >
}

export const AnyFilterSchema = createFilterInput(z.any())
export const StringFilterSchema = createFilterInput(z.string())
export const IntFilterSchema = createFilterInput(z.number().int())
export const DateFilterSchema = createFilterInput(z.date())

export type AnyFilter = z.infer<typeof AnyFilterSchema>
export type StringFilter = z.infer<typeof StringFilterSchema>
export type IntFilter = z.infer<typeof IntFilterSchema>
export type DateFilter = z.infer<typeof DateFilterSchema>
